export class NewCampaignTwo extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {    
    this.innerHTML = `
    <style>
      new-campaign-two .step-number-header {
        margin-bottom: 50px;
      }
      
      new-campaign-two .form-control {
        margin-bottom: 10px;
      }
      
      new-campaign-two .col-md-4 {
        padding-left: 0 !important;
      }
      
      #step-2-audio {
        padding: 0;
      }
      new-campaign-two webhook-form .col-md-2 {
        line-height: 36px !important;
        font-size: 18px;
      }
    </style>
    <div class="step-number-header">
      <div class="campaign-step-num"><span>2</span></div>
      <h4>Advanced Settings</h4>
    </div>
    <div class="step-container hidden">
      <div class="camp-line">
        <div class="camp-vertical-arrow hidden">
          <div class="camp-arrow-down"></div>
        </div>
      </div>
      <div class="step-main">
        <div class="panel panel-default campaign-panel">
          <div class="errors" data-cy="errors-2"></div>
          <div id="step-2-radio">
            <input type="radio" name="step-2-toggle" id="ring-to-radio" data-cy="ring-to-radio" checked>
            <label>Ring to Number</label>
            <input type="radio" name="step-2-toggle" id="call-treat-radio" data-cy="call-treat-radio">
            <label>Call Treatment</label>
          </div>
          <div id="ring-to-panel" data-cy="ring-to-panel">
            <input type="text" is="ring-to-endpoint" class="form-control ring_to_endpoint" id="new-camp-rtn" data-cy="new-camp-rtn" data-key="ring_to_endpoint" placeholder="(123) 444-5566 or SIP Target">
            <div id="step-2-audio" class="col-sm-12">
              <div class="col-sm-12 no-gutters"><label>Consumer Greeting</label></div>
              <div class="col-sm-12 no-gutters audio-select-row">
                <select is=audio-select target_audio_type=2 class="form-control" id="consumer-greeting-select" data-cy="consumer-greeting"></select>
                <button class="btn btn-secondary ct_manage_audio" data-audio-type-id="2">Manage</button>
              </div>
              <div class="col-sm-12 no-gutters"><label>Sales Rep Whisper</label></div>
              <div class="col-sm-12 no-gutters audio-select-row">
                <select is=audio-select target_audio_type=4 class="form-control" id="sales-rep-select" data-cy="sales-rep-whisper"></select>
                <button class="btn btn-secondary ct_manage_audio" data-audio-type-id="4">Manage</button>
              </div>
            </div>
            <div class="form-group form-horizontal col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 no-gutters" align="right" role="form">
              <label class="col-md-6 no-gutters" align="left">Call Ends - Assign Representative Code</label>
              <div class="col-md-6"  align="left">
                <label class="switch">
                  <input type="checkbox" class="form-control switch" id="representive-code-switch">
                  <span data-cy="representive-code-switch"></span>
                </label>
              </div>
            </div>
            <div class="form-group form-horizontal col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 no-gutters" align="right" role="form">
              <label class="col-md-6 no-gutters" align="left">Voicemail</label>
              <div class="col-md-2"  align="left">
                <label class="switch">
                  <input type="checkbox" class="form-control switch" id="voicemail-switch">
                  <span data-cy="voicemail-switch"></span>
                </label>
              </div>
              <div id="voicemail_rings_container" class="col-md-4 hidden">
                <label class="col-md-8">Number of Rings</label>
                <div class="col-md-4 no-gutters">
                  <select id="voicemail_rings" class="form-control">
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                  </select>
                </div>
              </div>
            </div>
            <div id="voicemail_audio" class="col-sm-12 no-gutters hidden">
              <div class="col-sm-12 no-gutters"><label>Voicemail Greeting</label></div>
              <div class="col-sm-12 no-gutters audio-select-row">
                <select is=audio-select target_audio_type=6 class="form-control" id="voicemail-greeting-select" data-cy="voicemail-greeting-select" default_option_text="Default"></select>
                <button class="btn btn-secondary ct_manage_audio" data-audio-type-id="6">Manage</button>
              </div>
            </div>
            <div class="panel-body form-group-separated form-horizontal">
              <div>
                <label class="control-label" style="margin-top: 20px">Webhook</label>
              </div>
              <div class="campaign_webhooks_container" data-cy="campaign-webhooks">
                <webhook-form></webhook-form>
              </div>
            </div>
          </div>
          <div id="call-treat-panel" data-cy="call-treat-panel" style="display:none;">
            <label>Call Treatment</label>
            <select is=treatments-select class="form-control call_treatments_id" data-cy="call-treat-id" value=""></select>
          </div>
        </div>
        <div class="campaign-buttons">                                                                        
          <button class="btn btn-primary pull-right detail-row-button" id="step-2-next" data-cy="step-2-next">Next</button>
          <button class="btn btn-outline-secondary pull-right detail-row-button step-cancel">Cancel</button>
        </div>
      </div>
    </div>
    `;

    this.querySelector('#step-2-next').addEventListener('click', function(e) {
      e.preventDefault();
      this.validateStep();
    }.bind(this))

    this.querySelectorAll('#step-2-radio input').forEach(radio => {
      radio.addEventListener('click', function() {
        let ringToPanel = this.querySelector('#ring-to-panel');
        let callTreatPanel = this.querySelector('#call-treat-panel');
        if(this.querySelector('#ring-to-radio').checked){
          ringToPanel.style.display = 'initial';
          callTreatPanel.style.display = 'none';
          this.querySelector('.call_treatments_id').value = "";
        } else if(this.querySelector('#call-treat-radio').checked) {
          ringToPanel.style.display = 'none';
          callTreatPanel.style.display = 'initial';
        }
      }.bind(this))
    })

    this.querySelector('#voicemail-switch').addEventListener('click', function() {
      if(this.querySelector('#voicemail-switch').checked == false) {
        this.querySelector('#voicemail_rings_container').classList.add('hidden');
        this.querySelector('#voicemail_audio').classList.add('hidden');
      } else {
        this.querySelector('#voicemail_rings_container').classList.remove('hidden');
        this.querySelector('#voicemail_audio').classList.remove('hidden');
      }
    }.bind(this))
  }

  validateStep() {
    this.querySelector('.errors').innerHTML = "";
    if(this.querySelector('#ring-to-radio').checked && !this.querySelector('#new-camp-rtn').value) {
      this.querySelector('.errors').innerHTML = `<div class="alert alert-danger alert-dismissible" role="alert">
                                                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                  <strong>Warning!</strong> Please provide a phone number.
                                                </div>`;
      return false
    } else if(this.querySelector('#call-treat-radio').checked && !this.querySelector('.call_treatments_id').value) {
      this.querySelector('.errors').innerHTML = `<div class="alert alert-danger alert-dismissible" role="alert">
                                                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                  <strong>Warning!</strong> Please select a call treatment.
                                                </div>`;
      return false
    } else {
      this.querySelector('.campaign-buttons').classList.add('hidden');
      this.querySelector('.camp-vertical-arrow').classList.remove('hidden');
      document.querySelector('new-campaign-three').revealStep();
      return true
    }
  }

  revealStep() {
    this.querySelector('.step-number-header').style.marginBottom = 0;
    this.querySelector('.step-container').classList.remove('hidden');
    this.querySelector('.campaign-step-num').classList.add('campaign-step-active');
    this.querySelector('.step-number-header').scrollIntoView({behavior: "smooth"});
  }
}

customElements.define('new-campaign-two', NewCampaignTwo)